export default __webpack_public_path__ + "static/media/13_hranice-chraneneho-uzemi-min.f07859d6.jpg";